import moment from "moment";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function AccountPlanCard({
  uuid,
  cardDetails,
  currentPlanLoader,
  trialCheck,
  handleChildData,
}) {
  console.log(trialCheck);
  return (
    <Row className="m-0 h-100">
      <Col md="16" lg="14" xl="12" xxl="10" className="ps-0">
        <div
          className="p-4 pb-0 border rounded bg-white mb-5 h-100"
          style={{ boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px" }}
        >
          {!currentPlanLoader && (
            <div className="p-3 pb-0">
              <div className="">
                <div className="mb-5">
                  <h1 className="mb-3">{cardDetails.name}</h1>
                  <div className="text-info fs-36 fw-bold">
                    {" "}
                    £{cardDetails.price}
                  </div>
                  <div className="fw-semibold bold-colour">
                    {cardDetails.renewalTyp === "yearly"
                      ? "per year"
                      : "per month"}
                  </div>
                </div>
                <p className="fw-semibold bold-colour mb-2">
                  <span class="text-success me-2">&#10004;</span>
                  {cardDetails.availableS === 1 ? (
                    <span>{cardDetails.availableS} Main user</span>
                  ) : (
                    <span>{cardDetails.availableS} Main users</span>
                  )}
                </p>
                <p className="fw-semibold bold-colour mb-2">
                  <span class="text-success me-2">&#10004;</span>
                  {cardDetails.availableS === 1 ? (
                    <span>{cardDetails.availableS} support user</span>
                  ) : (
                    <span>{cardDetails.availableS} support users</span>
                  )}
                </p>
                <p className="fw-semibold bold-colour mb-2">
                  <span class="text-success me-2">&#10004;</span>
                  Cancel any time
                </p>
                <p className="fw-semibold bold-colour mb-2">
                  <span class="text-success me-2">&#10004;</span>
                  No hidden costs
                </p>
              </div>
              {trialCheck.status === "trialing" ? (
                <></>
              ) : (
                <div className="mt-5">
                  <Link to={`/downgradeSubscription/${uuid}`}>
                    <button className="btn btn-primary">Change Plan</button>
                  </Link>
                </div>
              )}
            </div>
          )}
          {currentPlanLoader && (
            <div>
              <div className="text-center">
                <button className="btn loading-btn p-0" type="button">
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Loading Your Plan..
                </button>
              </div>
            </div>
          )}
        </div>
      </Col>

      <Col
        md="16"
        lg="14"
        xl="12"
        xxl="10"
        className="ps-0 ps-xl-5 pt-5 pt-xl-0"
      >
        <div
          className="p-4 border rounded bg-white mb-5 h-100"
          style={{ boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px" }}
        >
          {!currentPlanLoader && (
            <div className="p-3 pb-0">
              <div>
                <div className="d-flex align-items-center gap-2">
                  <h1>Subscription status</h1>{" "}
                  <i
                    className="fa fa-info-circle mb-1"
                    style={{ cursor: "pointer" }}
                    title={
                      trialCheck.status === "trialing"
                        ? " If you don't cancel your subscription before that, your paid subscription would start and your card would be charged."
                        : `Your subscription is ${trialCheck.status}`
                    }
                  ></i>
                </div>
                <div className="fw-semibold bold-colour mb-6">
                  {trialCheck.status === "trialing"
                    ? "Free trial"
                    : trialCheck.status
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                </div>
                <h1>Plan purchased on</h1>
                <div className="fw-semibold bold-colour mb-6">
                  {moment
                    .unix(trialCheck.start_date)
                    .format("MMMM Do YYYY, h:mm A")}
                </div>
                <h1>Next renewal </h1>
                <div className="fw-semibold bold-colour mb-7">
                  {trialCheck.status === "trialing"
                    ? moment
                        .unix(trialCheck.trial_end)
                        .format("MMMM Do YYYY, h:mm A")
                    : moment
                        .unix(trialCheck.current_period_end)
                        .format("MMMM Do YYYY, h:mm A")}
                </div>
              </div>
              <button
                className="btn btn-primary"
                onClick={handleChildData}
                style={{ marginTop: "5px" }}
              >
                {trialCheck.status === "trialing"
                  ? "Cancel Free Trial"
                  : "Cancel your account"}
              </button>
            </div>
          )}
          {currentPlanLoader && (
            <div>
              <div className="text-center">
                <button className="btn loading-btn p-0" type="button">
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Loading Your Plan..
                </button>
              </div>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
}

export default AccountPlanCard;
